@use '../../../../assets/styles/utilities.scss';

:host {
  display: block;
}

.header-badge {
  padding: 0.25rem 0.5rem;
  font-size: 0.625rem;
  font-weight: 600;
  border-radius: 9999px;
  display: inline;
  transition: all 15s ease-in-out;
  text-align: center;
  white-space: nowrap;
  background-color: #dc2626;
  color: white;
  border: 1px solid #dc2626;
}

.btmbar_badge {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  padding: 2px 3px;
  line-height: normal;
  border-radius: 0px;
  padding: 0px;
}

// Apply animation only if blinking
.header-badge.blinking {
  animation: blink 1s infinite;
}

@keyframes blink {
  0%,
  100% {
    background-color: #dc2626;
    color: white;
    border-color: #dc2626;
  }

  50% {
    background-color: white;
    color: #dc2626;
    border-color: #dc2626;
  }
}
